import JSEncrypt from 'jsencrypt';

const pubkey = `-----BEGIN PUBLIC KEY-----
        MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArromvW2N/rg0ADw9zpTL
        cGdO0wNazPcp+SepPrv1dicCamEVPfvPKlWMuYszt/tE6lNjMT8pphmatPvgjAFy
        KfE1fEpcvHqRSZTUtlo/fGJzh2nss6mxyDXlqi+sGitjwaGj6/MXO6zLQcMQmZ/U
        vliOhECvuLBsAqqLY8ik63Ah7ylWAap3jDD0OvgSy+glqebwfacy9WPYOy4K75n/
        DQRw9FJBYFg1BtfbVn55Oji3AZ0E3lY96b0JhJGtFM6vjF0bhVDkmP/XZINPcVZy
        xydRFvxjgA6we/KmxXDD/JdZmvGmrZ2XCAhGS3vuk3XJnkMquGYO4GAI13JIs8Z1
        rwIDAQAB
        -----END PUBLIC KEY-----
    `;

export function Jsencrypt(pwd: string): string {
  const crypt = new JSEncrypt();
  crypt.setKey(pubkey);
  const crypted = crypt.encrypt(pwd);
  if (!crypted) {
    return '';
  }
  return crypted;
}

export function unToken(headers?: Record<string, any>): Record<string, any> {
  return {
    headers: { Authorization: null, ...headers },
  };
}
